import { styled } from '@volkswagen-onehub/components-core';
import { AriaLabels } from '../VehicleCardsCarousel/VehicleCardsCarousel';

export const VehicleCardsContainerWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  gap: ${theme.size.static350};

  [aria-label='${AriaLabels.NAVIGATION_ARIA_LABEL}'] {
    margin-top: ${theme.size.static300};
  }

  *:focus {
    box-shadow: none;
  }

  [aria-roledescription='slide'] > div {
    display: flex;
    height: 100%;
  }
`
);

interface VehicleCardWrapperProps {
  slideOffsetY: string;
}

export const VehicleCardWrapper = styled.div<VehicleCardWrapperProps>(
  ({ slideOffsetY }) => `
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  padding-top: ${slideOffsetY};
`
);
